import { Suspense, useEffect, useState } from 'react';
import { getKeyLabel } from '..';
import { useParentSize } from '../../../hooks/useParentSize';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { getOSName } from '../../../util';
import { Button, ButtonVariant } from '../../Button';
import { Dialog } from '../../Dialog';
import { Label } from '../../Label';
import { Flow } from '../../Layouts/Flow';
import { GroupHeaderItem, Item, List } from '../../List';
import { useListState } from '../../List/useListState';
import { SearchField } from '../../SearchField';
import bundle from '../NovaComponents-KeyboardShortcuts-gui-icu.properties';
import './DisplayDialog.css';
import cn from './DisplayDialog.css.json';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const DisplayDialog = props => {
  const localize = useTextLocalizer();
  const listState = useListState();
  const [searchValue, setSearchValue] = useState('');
  const {
    listData,
    matchCount
  } = getListData(props.shortcuts, localize, searchValue, props.hideBlank);
  const [setRef, dimensions] = useParentSize();
  useEffect(() => {
    // clear search value after close
    if (!props.isOpen) setSearchValue('');
  }, [props.isOpen]);
  return /*#__PURE__*/_jsx(Dialog, {
    isOpen: props.isOpen,
    testId: props.testId,
    title: localize('displayDialog.dialog.title'),
    resizable: true,
    size: {
      width: '60rem',
      height: '48rem',
      minHeight: '20rem'
    },
    dismissAction: {
      text: localize('close.button.label'),
      onPress: props.onClose
    },
    subContentFooterControl: /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: /*#__PURE__*/_jsx(Label, {
        helpPopup: {
          contentKey: 'keyboard.shortcutKeysNote',
          library: 'novacmneua-gui-eua'
        },
        children: localize('footNote.msg')
      })
    }),
    footerControls: props.hideLinkToManage ? undefined : /*#__PURE__*/_jsx(Button, {
      className: cn.linkButton,
      text: localize('linkToManage.label'),
      variant: ButtonVariant.Light,
      onPress: props.onLinkPress
    }),
    children: /*#__PURE__*/_jsxs(Flow, {
      className: cn.content,
      orientation: "vertical",
      children: [/*#__PURE__*/_jsx(SearchField, {
        className: cn.searchField,
        value: searchValue,
        onChange: e => {
          listState.clearMeasurementCache({
            startRowIndex: 0,
            startColumnIndex: 0
          });
          setSearchValue(e.value);
        },
        filterMode: true,
        numberOfResults: matchCount
      }), /*#__PURE__*/_jsx("div", {
        className: cn.listContainer,
        children: /*#__PURE__*/_jsx("div", {
          ref: setRef,
          className: cn.listParent,
          children: /*#__PURE__*/_jsx(List, {
            ...listState,
            ariaLabel: localize('actionsAndShortcuts.aria'),
            rowCount: listData.length,
            height: dimensions?.height,
            width: dimensions?.width,
            showSeparator: () => true,
            renderItem: ({
              index
            }) => {
              const item = listData[index];
              if ('group' in item) return /*#__PURE__*/_jsx(GroupHeaderItem, {
                title: item.group
              });
              return /*#__PURE__*/_jsx(Item, {
                highlight: {
                  text: searchValue
                },
                title: item.title,
                info: {
                  infoText: item.info,
                  hasPriority: true
                }
              });
            }
          })
        })
      })]
    })
  });
};
function getListData(shortcuts, localize, searchValue, hideBlank) {
  const platform = getOSName().toLowerCase();
  const listData = [];
  const lowercaseValue = searchValue.toLowerCase();
  let matchCount = 0;
  for (const i in shortcuts) {
    if (shortcuts.hasOwnProperty(i)) {
      const group = shortcuts[i];
      if (group.description.endsWith('.label')) group.description = localize(group.description);
      listData.push({
        group: group.description
      });
      const prevCount = matchCount;
      const actionList = group.actions;
      for (const j in actionList) {
        if (actionList.hasOwnProperty(j)) {
          const action = actionList[j];
          const defaults = action.default[platform];
          let keys = action[platform];
          let keysInfo = '';
          if (action.description.endsWith('.label')) action.description = localize(action.description);
          if (!keys && defaults) {
            keys = defaults;
          }
          if (keys) {
            keysInfo = getKeyLabel(keys[0] || keys[1], localize);
            if (keys[0] && keys[1]) {
              keysInfo += `\n${getKeyLabel(keys[1], localize)}`;
            }
          }
          if (!keysInfo) {
            keysInfo = hideBlank ? '' : localize('notDefined.label');
          }
          if (keysInfo && (!searchValue || action.description.toLowerCase().includes(lowercaseValue) || keysInfo.toLowerCase().includes(lowercaseValue))) {
            matchCount++;
            listData.push({
              title: action.description,
              info: keysInfo
            });
          }
        }
      }
      if (prevCount === matchCount) {
        // no matching item, remove the group header
        listData.pop();
      }
    }
  }
  return {
    listData,
    matchCount
  };
}
//# sourceMappingURL=DisplayDialog.js.map